import { render, staticRenderFns } from "./ActionsWrapper.vue?vue&type=template&id=4fa53a42&lang=pug"
import script from "./ActionsWrapper.vue?vue&type=script&lang=js"
export * from "./ActionsWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports